import React from 'react';
import Plugin, { PluginProps } from '../Plugin';
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
const DEFAULT_BUTTON_BACKGROUND_COLOR = 'rgb(22,50,153)';

const ModalBlock = (props: PluginProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { content } = props;
  const contentData = content.data;
  const header_text = contentData?.header_text;
  const button_text = contentData?.button_text || 'Learn More';
  const size = contentData?.size;
  const width = contentData?.width;
  const color_scheme = contentData?.color_scheme;
  
  // Button styling with fallbacks for new fields
  const buttonStyle = {
    fontSize: contentData?.button_font_size || '16px',
    color: contentData?.button_font_color || '#ffffff',
    backgroundColor: contentData?.button_background_color || DEFAULT_BUTTON_BACKGROUND_COLOR,
    padding: contentData?.button_padding || '12px 24px',
    borderRadius: contentData?.button_border_radius || '6px',
    border: contentData?.button_border || 'none',
    cursor: contentData?.button_cursor || 'pointer',
    fontWeight: contentData?.button_font_weight || '500',
  };

  return (
    <>
      <Button onClick={onOpen} style={buttonStyle}>{button_text}</Button>

      <Modal
        isOpen={isOpen}
        size={width == null ? size : undefined}
        colorScheme={color_scheme}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          {header_text && <ModalHeader>{header_text}</ModalHeader>}
          <ModalCloseButton />
          <ModalBody width={width}>
            {content.children.map((child, index) => {
              return <Plugin key={index} {...props} content={child} />;
            })}
          </ModalBody>

          {/* <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Close
            </Button>
            <Button variant='ghost'>Secondary Action</Button>
          </ModalFooter> */}
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalBlock;
